import React, { useState } from 'react';
import { ChevronDown, ChevronUp, HelpCircle } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Cómo recibo el material?',
    a: 'El acceso es inmediato. Una vez realizado el pago, recibirás un correo electrónico con los enlaces de descarga de todo el material y los bonos de regalo.'
  }, {
    q: '¿Para qué edades es recomendable?',
    a: 'El Mega Pack está diseñado para niños de 3 a 12 años. Las actividades están organizadas por niveles de dificultad para que puedas elegir las más adecuadas para tu hijo.'
  }, {
    q: '¿Es un producto físico?',
    a: 'No, es un producto 100% digital (formato PDF). Esto te permite imprimir las actividades las veces que quieras y no tienes que esperar envíos ni pagar costos de transporte.'
  }, {
    q: '¿Qué pasa si no me gusta?',
    a: 'Tienes una garantía incondicional de 7 días. Si sientes que el material no aporta valor a tu familia, nos escribes y te devolvemos el 100% de tu dinero.'
  }];
  return <section className="bg-blue-50 py-20 px-4" data-id="element-104">
      <div className="max-w-3xl mx-auto" data-id="element-105">
        <div className="text-center mb-12" data-id="element-106">
          <HelpCircle className="w-12 h-12 text-blue-500 mx-auto mb-4" data-id="element-107" />
          <h2 className="text-3xl font-black text-gray-900" data-id="element-108">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-109">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-110" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white rounded-2xl shadow-sm border border-blue-100 overflow-hidden transition-all duration-300 hover:shadow-md" data-id="element-111">
      <button className="w-full flex justify-between items-center p-6 text-left font-bold text-gray-800 hover:bg-blue-50/50 transition-colors" onClick={() => setIsOpen(!isOpen)} data-id="element-112">
        <span className="text-lg" data-id="element-113">{question}</span>
        {isOpen ? <ChevronUp className="w-6 h-6 text-blue-500 bg-blue-100 rounded-full p-1" data-id="element-114" /> : <ChevronDown className="w-6 h-6 text-gray-400 bg-gray-100 rounded-full p-1" data-id="element-115" />}
      </button>
      {isOpen && <div className="p-6 pt-0 text-gray-600 leading-relaxed" data-id="element-116">{answer}</div>}
    </div>;
}